<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Edit User</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                v-model="Form.firstName"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="userForm"
                :error-messages="errors.collect('userForm.firstName')"
                hide-details
                :counter="50"
                label="First Name*"
                name="firstName"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.lastName"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="userForm"
                :error-messages="errors.collect('userForm.lastName')"
                hide-details
                :counter="50"
                label="Last Name*"
                name="lastName"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.fullName"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="userForm"
                :error-messages="errors.collect('userForm.fullName')"
                hide-details
                :counter="50"
                label="Full Name*"
                name="fullName"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.userEmail"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="userForm"
                :error-messages="errors.collect('userForm.userEmail')"
                hide-details
                :counter="50"
                label="User Email*"
                name="userEmail"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.emailVerificationCode"
                :counter="50"
                label="Email Verification Code"
                name="emailVerificationCode"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.language"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="userForm"
                :error-messages="errors.collect('userForm.language')"
                hide-details
                :counter="50"
                label="Language*"
                name="language"
              />
            </v-flex>
            <v-flex xs12 v-if="parseInt(user.userLevel) == 100">
              <v-select
                v-model="Form.userLevel"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="userForm"
                :items="lookupList('userlevel')"
                :error-messages="errors.collect('userForm.userLevel')"
                hide-details
                item-text="text"
                item-value="value"
                label="User Level*"
                name="userLevel"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                multiple
                label="Portals"
              />
            </v-flex>
            <v-flex xs12 class="input-container">
              <span v-if="Form.emailVerified" style="padding-top: 25px;">Email Verified</span>
              <span v-else style="padding-top: 25px;">Email Verified</span>
              <v-switch v-model="Form.emailVerified" style="padding-left: 15px;"></v-switch>
            </v-flex>
            <v-flex xs12 class="input-container">
              <span v-if="Form.isSponsor" style="padding-top: 25px;">Sponsor</span>
              <span v-else style="padding-top: 25px;">Sponsor</span>
              <v-switch v-model="Form.isSponsor" style="padding-left: 15px;"></v-switch>
            </v-flex>
            <small>*indicates required field</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('userForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      handler: function() {
        if (this.form.portalID) {
          this.Form.portalID = this.form.portalID;
        }
        if (this.form.isSponsor) {
          this.Form.isSponsor = this.form.isSponsor;
        }
        if (this.form.firstName) {
          this.Form.firstName = this.form.firstName;
        }
        if (this.form.lastName) {
          this.Form.lastName = this.form.lastName;
        }
        if (this.form.userLevel) {
          this.Form.userLevel = this.form.userLevel;
        }
        if (this.form.userEmail) {
          this.Form.userEmail = this.form.userEmail;
        }
        if (this.form.sponsorID) {
          this.Form.sponsorID = this.form.sponsorID;
        }
      },
      deep: true
    },
    formaction: {
      type: String,
      default: ""
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
      confirmPin: null,
      emailDomain: null,
      emailVerificationCode: null,
      emailVerified: null,
      firstName: null,
      fullName: null,
      isSponsor: null,
      language: null,
      lastName: null,
      organisationID: null,
      password: null,
      passwordResetCode: null,
      portalID: {},
      sponsorID: null,
      userEmail: null,
      userID: null,
      userLevel: null
    }
  }),
  computed: {
    ...mapGetters({
      lookupList: "portal/lookupList"
    }),
    ...mapState({
      user: state => state.user.active
    })
  },
  mounted() {
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  watch: {
    form() {
      this.Form = this.form;
    }
  },
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
      this.Form = {};
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          // console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Settings/createDocument", [
                this.settings.Collection,
                this.Form,
                "Settings/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              // console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              // console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Settings/updateDocument", [
                this.settings.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>
